
define('jst!presence/presence_bar/_avatar',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<img src="<%- avatar_url_for(user, \'small\') %>" title="<%= user.get(\'name\') %>" class="tooltip" data-tooltip-gravity="s" width="24" height="24" />');
 });

